
function useTwoStepUpdate<T>(getValue: () => T | null, updateValue: (value: T | null, isNew: boolean) => void) {

    function handleTwoStepUpdate(immediateResult: T | null | undefined, deferredResult: Promise<T | null | undefined>) {
        const originalValue : T | null = getValue();
        const doUpdate: (value: T | null | undefined) => void = (value) => {
            if (!!value) {
                updateValue(value, true);
            }  else {
                updateValue(originalValue, false);
            }
        };
        doUpdate(immediateResult);
        deferredResult.then(doUpdate).catch(() => doUpdate(null));
    }

    return { handleTwoStepUpdate };

}

export default useTwoStepUpdate;